import { FlagShipModificationValues } from '@abtasty/api-client';

import { useAccountData } from '../shared/tag/context/useTagData';

export const useAccountId = (): number | undefined => {
  const { accountId } = useAccountData();

  return accountId;
};

export const useFlagshipActivation = (...keys: (keyof FlagShipModificationValues | string)[]) => {
  const { flagship: flags } = useAccountData();

  return keys.map<boolean>((k) => flags[k]);
};

export const useRole = () => {
  const { role } = useAccountData();
  return role;
};

export const useSharding = () => {
  const { useSharding } = useAccountData();
  return useSharding;
};

export const useTagLatestCompilationDate = () => {
  const { lastUpdateDate } = useAccountData();
  return lastUpdateDate;
};
